import { MARKETING_API } from '@/constants/API';
import { request } from '@umijs/max';

// 社媒分析
//   export async function assistantIdSocialMedia({
//     assistantId,
//   }: {
//     assistantId: string | undefined;
//     state?: string | number;
//   }) {
//     return request(`${MARKETING_API}/assistant/analysis/social_media/${assistantId}`, {
//       method: 'get',
//     });
//   }
// 营销日历 列表
export async function getMarketingCalendarList(params: any) {
  return request(`${MARKETING_API}/marketing/calendar/list`, {
    method: 'POST',
    data: {
      ...params,
    },
  });
}

// 获取品牌列表
//   export async function serBrandList({
//     assistantId,
//     state = '',
//   }: {
//     assistantId: string | undefined;
//     state?: string | number;
//   }) {
//     return request(`${MARKETING_API}/brand/list/${assistantId}?state=${state}`, {
//       method: 'get',
//     });
//   }

// 埋点接口
export async function operationLog(params: any) {
  return request(`${MARKETING_API}/operation_log/${params.id}/${params.type}`, {
    method: 'PUT',
  });
}
// 今日详情
export async function http_day_info({}) {
  return request(`${MARKETING_API}/marketing/calendar/day_info`, {
    method: 'get',
  });
}

// 生成画面
export async function adhesiveBandageGenerateAnImage(params: any) {
  return request(`${MARKETING_API}/hotspot/scheme/image/adhesiveBandageGenerateAnImage`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}

// 生成画面图片获取
export async function selectTaskImageLists(params: any) {
  return request(`${MARKETING_API}/adhesive/bandage/image/selectTaskImageLists`, {
    method: 'POST',
    data: {
      ...params,
      appId: process.env.appId,
    },
  });
}